import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styles from "./AriaLive.module.css";
import { getAriaLive } from "../../../store/ariaLive/selectors.js";
import { isFeatureRunningClientSide } from "@flights/web-api-utils-universal";
const AriaLive = () => {
    const [ariaType, setAriaType] = useState(undefined);
    const [ariaMessage, setAriaMessage] = useState(undefined);
    const ariaLive = useSelector(getAriaLive);
    useEffect(() => {
        setAriaType(ariaLive.type);
        if (ariaLive.message) {
            setAriaMessage(ariaLive.message);
            if (isFeatureRunningClientSide("FLIGHTS_PRICING_CLEAR_ARIA_LIVE_MESSAGE_AFTER_ANNOUNCEMENT")) {
                const timeoutId = setTimeout(() => {
                    setAriaMessage(undefined);
                }, 500);
                return () => clearTimeout(timeoutId);
            }
        }
        return;
    }, [ariaLive]);
    return (React.createElement("p", { "aria-live": ariaType, className: styles.message }, ariaMessage));
};
export default AriaLive;
